import "#/legacy/jquery-global.js";

window.Sparkle ??= {};
window.Sparkle.Config ??= {};
window.Sparkle.apiKeys ??= {};
window.Sparkle.Config.googleMaps ??= {};

const sparkleDefaults = {
  Models: {},
  Collections: {},
  Views: {},
  Routers: {},
  Components: {},
  Controllers: {},
  apiKeys: {},
  Config: {},
  FormBuilder: {},
  Utilities: {},
  Pagebuilder: {
    active: jQuery("html").hasClass("page-builder"),
  },
};

Object.entries(sparkleDefaults).forEach(([key, value]) => {
  window.Sparkle[key] ??= value;
});

window.Sparkle.env = window.SparkleConfig?.env;
window.Sparkle.apiKeys.googleMaps = window.SparkleConfig?.apiKeys?.googleMaps;

// Resolved on each read, because an embedded page sets `Sparkle.currentPublishingDomain` and
// `SparkleConfig` after this module has evaluated.
function currentPublishingDomainConfig() {
  return window.SparkleConfig?.publishingDomains?.[window.Sparkle.currentPublishingDomain];
}

window.Sparkle.Config.googleMaps = {
  get mapCenter() {
    return currentPublishingDomainConfig()?.mapCenter;
  },
  get geocoderBounds() {
    return currentPublishingDomainConfig()?.geocoderBounds;
  },
};

window.Sparkle.Config.breakpoint = {
  smallest: "750px",
};

// I18n translation lookup. Resolves a dotted key (e.g. "admin.components.messages.remove")
// against the translations exported by i18n-js. Supports simple %{name} interpolation.
window.Sparkle.t = function (key, options) {
  var translations = (window.SparkleConfig || {}).translations;
  if (!translations) {
    return key;
  }

  var parts = key.split(".");
  var value = translations;
  for (var i = 0; i < parts.length; i++) {
    if (value == null) {
      return key;
    }
    value = value[parts[i]];
  }
  if (value == null) {
    return key;
  }
  if (typeof value !== "string") {
    return value;
  }
  if (options) {
    Object.keys(options).forEach(function (name) {
      value = value.replace(new RegExp("%\\{" + name + "\\}", "g"), options[name]);
    });
  }
  return value;
};
